import { GlobalFilter } from "modules/filters/context/filterContext";

const isGlobalFilter = (filter: string, globalFilters?: GlobalFilter) =>
  globalFilters
    ? Object.keys(globalFilters).some((globalFilter) => globalFilter === filter)
    : false;

export default isGlobalFilter;
